import React, { useState ,useEffect} from "react";
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Tooltip,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Chip,
  Divider
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import HelpIcon from '@mui/icons-material/Help';

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';

import { create } from "../../Store/projectPermission/permssionReducer";

import Projectcolors from "../../Utils/Colors";

import optimizelogo from "../../images/logooptimizegsfinal.png";
import gpticon from "../../images/gpticon.png";
import selexsuite from "../../images/SelexSuite.png";
import SelexMBlogo from "../../images/SelexMB Final.png";
import selexsim from "../../images/SelexSIM.png";
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { ArrowLeftCircleIcon } from "lucide-react";
import ArticleIcon from '@mui/icons-material/Article';

const navy = "#061d34";


function SelexSolNavbar(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(
  !!sessionStorage.getItem("usertoken")
);
const [releaseOpen, setReleaseOpen] = React.useState(false);
const [releaseExplorerOpen, setExplorerReleaseOpen] = React.useState(false);


const releaseVersions = [
  {
    version: "Version 2.6XP",
    title: "Dynamic Optimization",
    details: [
      "Dynamic Optimization module added",
      "Supports one objective function",
      "Improved workflow for optimization cases",
    ],
  },
  {
    version: "Version 2.8XP",
    title: "Dynamic Optimization Upgrade",
    details: [
      "Dynamic Optimization module added",
      "Supports multiple objective function",
      "Enhanced SelexStudio workflow",
    ],
  },
  {
    version: "Version 3.0XP",
    title: "Advanced SelexStudio Release",
    details: [
      "Updated interface and release structure",
      "Supports multiple objective function",
      "Improved model loading and project handling",
      "Better support for managing Categorical DEP",
    ],
  },
];


const releaseExplorerVersions = [
  {
    version: "Version 2.6XP",
    title: "Machine Learning and MLOps Projects",
    details: [
      "This is for the ML and MLOPs projects. No First Principles Concept"
    ]
  },
  {
    version: "Version 2.6XP_FP",
    title: " First Principles Upgrade",
    details: [
      "This version include the First Principles equations.",
      "Case Study and Dynamic Optimization are not capturing the FP parameters",
    ],
  },
  {
    version: "Version 2.6XFP",
    title: "Advanced SelexMB Explorer Release",
    details: [
     "This version include the First Principles equations.",
     "Case Study and Dynamic Optimization are capturing the FP parameters",
     "Binary Classification Algorithm is included in the MLOPs Engine"
    ],
  },
];

  function logout() {
    sessionStorage.removeItem("usertoken");
    sessionStorage.removeItem("projectID");
    sessionStorage.removeItem("projectName");
    sessionStorage.removeItem("cadence_user");
    sessionStorage.removeItem("cadence_workspace_id");
    sessionStorage.removeItem("cadence_api_base");


    dispatch(create([{ empty: true }]));

    if (props.admin) {
      navigate("/admin");
    } else {
      if(location.pathname == "/selexstudio2" || location.pathname == "/selexstudio/v2-6xp" || location.pathname == "/selexstudio/v2-8xp" || location.pathname == "/selexstudio/v3-0xp"  || location.pathname == "/home"||location.pathname == "/newproject"||location.pathname == "/selexmbexplorer" || location.pathname == "/selexmbexplorer/" || location.pathname == "/selexmbexplorer/v2-6xp" || location.pathname == "/selexmbexplorer/v2-6xpfp" || location.pathname == "/selexmbexplorer/v2-6xfp"   )
      {
      navigate("/selexmblanding");
      }
      else if (location.pathname == "/selexmsd" || location.pathname == "/selexcam2" || location.pathname == "/selexsim/selexstudio2" || location.pathname == "/selexsim/selexstudio/v2-6xp" || location.pathname == "/selexsim/selexstudio/v2-8xp" || location.pathname == "/selexsim/selexstudio/v3-0xp"){
        navigate("/selexsimlanding")
      }
      else if (location.pathname == "/selexoracle"){
        navigate("/selectselexrisk")
      }
      else if (location.pathname == "/cadence"){
        navigate("/businessuserlogin")
      }
      else if (location.pathname == "/businessapps"){
        navigate("/businessuserlogin")
      }
      else{
        navigate("/")
      }
    }
  }

  console.log(props)
const selexMBRoutes = ["/home", "/newproject", "/help"];

const selexSimRoutes = [
  "/selexsim",
  "/selexsimlanding",
  "/selexsim-help",
];
  const currentLogo = selexMBRoutes.includes(location.pathname)
  ? {
      href: "/select",
      logo: SelexMBlogo,
      alt: "SelexMB Logo",
    }
  : selexSimRoutes.includes(location.pathname)
  ? {
      href: "/selexsimlanding",
      logo: selexsim,
      alt: "SelexSim Logo",
    }
  : {
      href: "/select",
      logo: optimizelogo,
      alt: "Optimize Logo",
    };


  return (
    <Box sx={{ pb: "92px" }}>

      
          <Dialog
        open={releaseOpen}
        onClose={() => setReleaseOpen(false)}
        maxWidth="sm"
        
        PaperProps={{
          sx: {
            borderRadius: "22px",
            overflow: "hidden",
            boxShadow: "0 24px 70px rgba(0,0,0,0.25)",
            transform: "translateY(40px)",
          },
        }}
      >
        <DialogTitle
          sx={{
            background: "linear-gradient(135deg, #0078c9, #0d8fe6)",
            color: "#fff",
            fontWeight: 900,
            fontSize: 20,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 1,
            px: 3,
          }}
        >
          SelexStudio Release Notice
      
          <IconButton onClick={() => setReleaseOpen(false)} sx={{ color: "#fff" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      
        <DialogContent sx={{ background: "#f8fafc", p: 3 }}>
          {releaseVersions.map((item, index) => (
            <Box
              key={item.version}
              sx={{
                background: "#fff",
                borderRadius: "18px",
                p: 3,
                mb: 1,
                mt:2,
                border: "1px solid rgba(0,120,201,0.12)",
                boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mb: 1 }}>
                <Chip
                  label={item.version}
                  sx={{
                    background: "rgba(0,120,201,0.1)",
                    color: "#0078c9",
                    fontWeight: 800,
                    fontSize: 12,
                  }}
                />
      
                <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#061d34" }}>
                  {item.title}
                </Typography>
              </Box>
      
              <Divider sx={{ my: 1.5 }} />
      
              {item.details.map((detail) => (
                <Typography
                  key={detail}
                  sx={{
                    fontSize: 13,
                    color: "#475569",
                    mb: 0.7,
                    lineHeight: 1.7,
                  }}
                >
                  • {detail}
                </Typography>
              ))}
            </Box>
          ))}
        </DialogContent>
      </Dialog>
      


          <Dialog
        open={releaseExplorerOpen}
        onClose={() => setExplorerReleaseOpen(false)}
        maxWidth="sm"
        
        PaperProps={{
          sx: {
            borderRadius: "22px",
            overflow: "hidden",
            boxShadow: "0 24px 70px rgba(0,0,0,0.25)",
            transform: "translateY(40px)",
          },
        }}
      >
        <DialogTitle
          sx={{
            background: "linear-gradient(135deg, #0078c9, #0d8fe6)",
            color: "#fff",
            fontWeight: 900,
            fontSize: 20,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 1,
            px: 3,
          }}
        >
          SelexMB Explorer Release Notice
      
          <IconButton onClick={() => setExplorerReleaseOpen(false)} sx={{ color: "#fff" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      
        <DialogContent sx={{ background: "#f8fafc", p: 3 }}>
          {releaseExplorerVersions.map((item, index) => (
            <Box
              key={item.version}
              sx={{
                background: "#fff",
                borderRadius: "18px",
                p: 3,
                mb: 1,
                mt:2,
                border: "1px solid rgba(0,120,201,0.12)",
                boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mb: 1 }}>
                <Chip
                  label={item.version}
                  sx={{
                    background: "rgba(0,120,201,0.1)",
                    color: "#0078c9",
                    fontWeight: 800,
                    fontSize: 12,
                  }}
                />
      
                <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#061d34" }}>
                  {item.title}
                </Typography>
              </Box>
      
              <Divider sx={{ my: 1.5 }} />
      
              {item.details.map((detail) => (
                <Typography
                  key={detail}
                  sx={{
                    fontSize: 13,
                    color: "#475569",
                    mb: 0.7,
                    lineHeight: 1.7,
                  }}
                >
                  • {detail}
                </Typography>
              ))}
            </Box>
          ))}
        </DialogContent>
      </Dialog>
      <AppBar
        elevation={0}
        sx={{
          position: "fixed",
          top: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: "calc(100% - 40px)",
          maxWidth: "2400px",
          height: 78,
          borderRadius: "24px",
          background: "#fff",
          backdropFilter: "blur(18px)",
          border: "1px solid rgba(255,255,255,0.45)",
          boxShadow: "0 14px 45px rgba(0,0,0,0.10)",
          zIndex: 9999,
        }}
      >
        <Toolbar
          sx={{
            height: "78px",
            minHeight: "78px !important",
            px: { xs: 2, md: 3 },
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* LEFT LOGO + HOME */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>

        <Box
  component="a"
  href={currentLogo.href}
  sx={{
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
  }}
>
  <Box
    component="img"
    src={currentLogo.logo}
    alt={currentLogo.alt}
    sx={{
      height: 54,
      width: 150,
      objectFit: "contain",
    }}
  />
</Box>
 {location.pathname == "/aboutpage" || (props.isLoggedIn == false && location.pathname == "/selexmblanding" )|| location.pathname == "/blogs"|| location.pathname == "/allprojects" || location.pathname.startsWith("/blog/") || location.pathname.startsWith("/projects/") ?(

            <Tooltip title={<Typography fontSize={14}>SelexSuite Home</Typography>}>
              <IconButton
                href="/"
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: Projectcolors.primary || "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <HomeIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Tooltip>
          ):(null)}

          
             {location.pathname == "/selexsim/selexstudio/v2-6xp" || location.pathname == "/selexsim/selexstudio/v2-8xp" || location.pathname == "/selexsim/selexstudio/v3-0xp"   ?(

            <Tooltip title={<Typography fontSize={14}>SelexSIM Home</Typography>}>
              <IconButton
                href="/selexsimlanding"
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: Projectcolors.primary || "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <HomeIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Tooltip>
          ):(null)}



             {location.pathname == "/selexstudio/v2-6xp" || location.pathname == "/selexstudio/v2-8xp" || location.pathname == "/selexstudio/v3-0xp"   ?(

            <Tooltip title={<Typography fontSize={14}>SelexMB Home</Typography>}>
              <IconButton
                href="/selexmblanding"
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: Projectcolors.primary || "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <HomeIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Tooltip>
          ):(null)}

              {location.pathname == "/selexmbexplorer/v2-6xp" || location.pathname == "/selexmbexplorer/v2-6xpfp" || location.pathname == "/selexmbexplorer/v2-6xfp"   ?(

            <Tooltip title={<Typography fontSize={14}>SelexMB Explorer Home</Typography>}>
              <IconButton
                href="/selexmbexplorer"
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: Projectcolors.primary || "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <HomeIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Tooltip>
          ):(null)}

          

            {location.pathname == "/home" || location.pathname == "/selexstudio2" || location.pathname == "/selexmbexplorer/" || location.pathname == "/selexmbexplorer" ?(

            <Tooltip title={<Typography fontSize={14}>SelexMB Home</Typography>}>
              <IconButton
                href="/selexmblanding"
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: Projectcolors.primary || "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <HomeIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Tooltip>
          ):(null)}
            {location.pathname == "/newproject" || location.pathname == "/help" ?(

            <Tooltip title={<Typography fontSize={14}>SeelexMB Plus Home</Typography>}>
              <IconButton
                href="/home"
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: Projectcolors.primary || "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <HomeIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Tooltip>
          ):(null)}
          {location.pathname == "/login" ?(

            <Tooltip title={<Typography fontSize={14}>SelexSuite Home</Typography>}>
              <IconButton
                href="/"
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: Projectcolors.primary || "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <HomeIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Tooltip>
          ):(null)}
          {location.pathname == "/select" ?(

            <Tooltip title={<Typography fontSize={14}>SelexSuite Home</Typography>}>
              <IconButton
                href="/"
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: Projectcolors.primary || "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <HomeIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Tooltip>
          ):(null)}

          {location.pathname == "/selexmsd" || location.pathname == "/selexsim-help" || location.pathname == "/selexcam2"  || location.pathname == "/selexsim/selexstudio2" ?(

            <Tooltip title={<Typography fontSize={14}>SelexSIM Home</Typography>}>
              <IconButton
                href="/selexsimlanding"
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: Projectcolors.primary || "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <HomeIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Tooltip>
          ):(null)}

         
          {location.pathname == "/selexsimlanding"  || location.pathname == "/selectselexrisk"?(

            <Tooltip title={<Typography fontSize={14}>SelexSuite Home</Typography>}>
              <IconButton
                href="/"
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: Projectcolors.primary || "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <HomeIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Tooltip>
          ):(null)}

          {location.pathname == "/selexoracle" || location.pathname == "/selexrisk-help" ?(

            <Tooltip title={<Typography fontSize={14}>SelexRISK Home</Typography>}>
              <IconButton
                href="/selectselexrisk"
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: Projectcolors.primary || "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <HomeIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Tooltip>
          ):(null)}
           {location.pathname == "/selexrisk-help" ||  (props.isLoggedIn == true && location.pathname == "/selexmblanding" ) ?(

            <Tooltip title={<Typography fontSize={14}>SelexSuite Home</Typography>}>
              <IconButton
                href="/"
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: Projectcolors.primary || "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <HomeIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Tooltip>
          ):(null)}


          {location.pathname == "/adminhome" ?(

            <Tooltip title={<Typography fontSize={14}>Admin Home</Typography>}>
              <IconButton
                href="/admin"
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: Projectcolors.primary || "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <HomeIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Tooltip>
          ):(null)}

          </Box>
          

          {/* CENTER LOGO */}
          <Box
            component="a"
            href="/select"
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              display: { xs: "none", sm: "flex" },
              alignItems: "center",
              justifyContent: "center",
              textDecoration: "none",
            }}
          >
            <Box
              component="img"
              src={selexsuite}
              alt="SelexSuite"
              sx={{
                height: 150,
                width: 250,
                objectFit: "contain",
              }}
            />
          </Box>

          {/* RIGHT ACTIONS */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
            
            {location.pathname == "/home" || location.pathname == "/newproject" ?(
            <Tooltip title={<Typography fontSize={14}>Help</Typography>}>
              <IconButton
                href="/help"
                 
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
              <HelpIcon  sx={{
                    height: 28,
                    width: 28,
                    objectFit: "contain",
                  }} />

              </IconButton>
            </Tooltip> ):(
              null

            )}


           

           


              {location.pathname == "/selexmbexplorer" || location.pathname == "/selexmbexplorer/" || location.pathname == "/selexmbexplorer/v2-6xp" || location.pathname == "/selexmbexplorer/v2-6xpfp" || location.pathname == "/selexmbexplorer/v2-6xfp"   ?(
            <Tooltip title={<Typography fontSize={14}>Release Notice</Typography>}>
              <IconButton
                 
                onClick={() => setExplorerReleaseOpen(true)} 
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                              <ArticleIcon  sx={{ fontSize: 23 }} />

             
              </IconButton>
            </Tooltip> ):(
              null

            )}




                {isLoggedIn? (
            <Tooltip title={<Typography fontSize={14}>Logout</Typography>}>
              <IconButton
                onClick={logout}
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "14px",
                  background: "rgba(0,120,201,0.08)",
                  color: "#0078c9",
                  transition: "0.3s",
                  "&:hover": {
                    background: "#9e0b22",
                    color: "#fff",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <LogoutIcon sx={{ fontSize: 23 }} />
              </IconButton>
            </Tooltip> ):
            ( <Tooltip title={<Typography fontSize={14}>Login </Typography>}>
  <Button
      onClick={() =>
    navigate("/login", {
      state: { from: location.pathname }
    })
  }
    sx={{
      width: 140,
      height: 44,
      borderRadius: "14px",
      background: "linear-gradient(135deg, #005da0, #005da0)",
      color: "#fff",
      transition: "0.3s",
      textTransform: "none",
      fontWeight: 700,
      fontSize:14,

      "&:hover": {
        background: "#9e0b22",
        color: "#fff",
        transform: "translateY(-2px)",
      },
    }}
  >
    Login or Signup
  </Button>
</Tooltip>)};
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default SelexSolNavbar;